import React from 'react';
import { chips } from '../../data/stack';
import { SourceRef } from '../SourceRef';
export function SiliconTab() {
  return <section aria-labelledby="silicon-title" data-id="element-483" data-mp="2pjx8xxsn1mqi">
      <h2 id="silicon-title" className="font-serif text-2xl text-ink md:text-3xl" data-id="element-484" data-mp="2ukbdh5v16ejs">
        The chips
      </h2>
      <aside className="mt-4 max-w-3xl border-l-2 border-machine bg-machine/[0.06] px-4 py-3 text-[13.5px] text-ink/90" data-id="element-485" data-mp="2ylmzz2ilyjnr">
        Memory and status from vendor specs; performance claims are vendor marketing — we list them, we don’t endorse.
      </aside>
      <div className="mt-5 overflow-x-auto rounded-lg border border-line" data-id="element-486" data-mp="26uyvbghq6w5c">
        <table className="w-full min-w-[1100px] border-collapse text-[13.5px]" data-id="element-487" data-mp="2avisul67o1s0">
          <thead className="bg-surface text-left text-[12px] text-muted" data-id="element-488" data-mp="2fnalr2cuajlb">
            <tr data-id="element-489" data-mp="1j54opgo023tj">
              {['Chip', 'Maker', 'Class', 'Memory', 'Interconnect', 'Vendor performance claim', 'Status'].map(h => <th key={h} scope="col" className="whitespace-nowrap border-b border-line px-3 py-2.5 font-normal" data-id="element-490" data-mp="1n5okafsxczdk">
                  {h}
                </th>)}
            </tr>
          </thead>
          <tbody data-id="element-491" data-mp="22fhzjxaw5uzr">
            {chips.map(c => <tr key={c.name} className="border-b border-line/60 last:border-b-0" data-id="element-492" data-mp="1xn6w4kgxzr2g">
                <th scope="row" className="whitespace-nowrap px-3 py-3 text-left font-normal text-ink" data-id="element-493" data-mp="1xl3zvip751pa">
                  {c.name}
                  <SourceRef href={c.sourceUrl} data-id="element-494" data-mp="1npj1rvn90lkt" />
                </th>
                <td className="whitespace-nowrap px-3 py-3 text-muted" data-id="element-495" data-mp="1jnp29qoshnm8">{c.maker}</td>
                <td className="whitespace-nowrap px-3 py-3 text-muted" data-id="element-496" data-mp="1jps02ww6ol1i">{c.chipClass}</td>
                <td className="whitespace-nowrap px-3 py-3 font-mono text-[12.5px] text-ink" data-id="element-497" data-mp="1eoujgoqtnz24">{c.memory}</td>
                <td className="px-3 py-3 font-mono text-[12.5px] text-ink/85" data-id="element-498" data-mp="19rm56z8sof65">{c.interconnect}</td>
                <td className="whitespace-nowrap px-3 py-3 font-mono text-[12.5px]" data-id="element-499" data-mp="390j2b206clrs">
                  {c.claim ? <span className="text-ink/85" data-id="element-500" data-mp="12ed469g72x4n">
                      {c.claim}
                      <SourceRef href={c.sourceUrl} note="Vendor marketing claim — listed, not endorsed." data-id="element-501" data-mp="12cihapld4uxx" />
                    </span> : <span className="text-faint" data-id="element-502" data-mp="shi59pg0eupu">Not listed</span>}
                </td>
                <td className="whitespace-nowrap px-3 py-3" data-id="element-503" data-mp="xg1ubypwgmmf">
                  <span className={`rounded-full border px-2 py-0.5 font-mono text-[10.5px] ${c.status === 'Shipping' ? 'border-live/40 text-live' : 'border-machine/40 text-machine'}`} data-id="element-504" data-mp="1l4b9wiwise54">{c.status}</span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </section>;
}